import React from 'react'
import { Box, Button } from '@mui/material'
import {
    setFocus,
    useFocusable,
} from '@noriginmedia/norigin-spatial-navigation'
import { BackButton } from '@/shared/ui/Icons'
import {
    DETAILS_PAGE_BACK_BUTTON_FOCUS_KEY,
    DIRECTION_LEFT_FOCUS_KEY,
    DIRECTION_RIGHT_FOCUS_KEY,
    DIRECTION_UP_FOCUS_KEY,
    MENU_BUTTONS_FOCUS_KEY,
} from '@/shared/constants/focusLibraryConstants'
import { isSmartTV } from '@/shared/lib'

export const BackButtonComponent = ({ callback }: { callback: () => void }) => {
    const { ref: backButtonRef, focused: backButtonFocused } = useFocusable({
        focusable: true,
        forceFocus: true,
        focusKey: DETAILS_PAGE_BACK_BUTTON_FOCUS_KEY,

        onEnterPress: () => {
            callback()
        },

        onArrowPress: (direction) => {
            if (direction === DIRECTION_UP_FOCUS_KEY) {
                setFocus(MENU_BUTTONS_FOCUS_KEY)
                return false
            }

            if (direction === DIRECTION_LEFT_FOCUS_KEY) {
                return false
            }
            if (direction === DIRECTION_RIGHT_FOCUS_KEY) {
                return false
            }
            return true
        },
    })

    const backButton = {
        position: 'relative',
        zIndex: 2,
        // width: '30px',
        top: '10px',
        mb: '10px',
        left: '50px',
        border: backButtonFocused && isSmartTV() ? '5px solid red' : 'none',
    }

    return (
        <Box sx={backButton}>
            <Button ref={backButtonRef} onClick={callback}>
                <BackButton />
            </Button>
        </Box>
    )
}
